import { Component, ViewChild, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { GatewayServiceProvider, AlertService } from '../../../_services/services';
import { BookingQuoteModel } from "../../../_models/booking/booking-quote.model";
import { Global } from 'src/app/globals';
import utils from 'src/app/utils';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { AppSignaturePadComponent } from '../signature-pad/signature-pad.component';

@Component({
    selector: 'app-quote',
    standalone: true,
    imports: [
        SharedModule,
        MaterialModule
    ],
    templateUrl: './quote.component.html',
})

export class QuoteComponent implements OnInit {
    @Output() cancelQuote = new EventEmitter<any>();
    @Output() confirmQuote = new EventEmitter<BookingQuoteModel>();
    @Output() confirmSplitQuote = new EventEmitter<BookingQuoteModel>();
    @Input() qouteRemarks: string;
    @Input() isAlert: boolean;
    @Input() signature: string;
    @Input() showFarmAndFields: boolean;

    bookingQuote: BookingQuoteModel = new BookingQuoteModel();
    isSign: boolean = false;
    isSignatureRequired: boolean = false;
    maxIncidentDescriptionLength: number = 50;
    

    @Input() PendingSignatureRequiredStatus: boolean = false;


    @ViewChild('signature')
    public signaturePad!: AppSignaturePadComponent;

    public signatureImage: string;

    constructor(
        public globals: Global,
        private gatewayService: GatewayServiceProvider,
        public alertService: AlertService) {
        this.gatewayService.getAgentVersion((response) => {
            var version = parseInt(
                response.Version.replace(".", "").replace(".", "")
            );
            if (version <= 1840) {
                this.maxIncidentDescriptionLength = 50;
            } else {
                // this.maxIncidentDescriptionLength = 300;
                this.maxIncidentDescriptionLength = 150;
            }
        }, (error) => { })
        this.bookingQuote = new BookingQuoteModel();

    }

    ngOnInit(): void {

    }
    showImage() {
        this.bookingQuote.signatureImage = this.signatureImage;
        this.isSignatureRequired = false;
    }


    ngAfterViewInit() {
        if (this.signaturePad) {
            this.signaturePad.clear();

        }
    }

    drawComplete(signatureDataUrl?: string | Event) {
        const signatureImage = typeof signatureDataUrl === 'string'
            ? signatureDataUrl
            : this.signaturePad?.toDataUrl() || '';

        console.log('Completed drawing');
        console.log(signatureImage);
        if (this.isSignatureRequired) {
            if (!signatureImage || this.signaturePad.isEmpty()) {

                utils.confirmationDialog('Warning', "Signature is Required.", 'Close', (result) => {
                    if (result == 'Close') {
                        this.signatureImage = undefined;
                        this.signatureRequired();
                    }

                }, false);


            } else {
                let Signatureimage2: string = this.getSignaturePayload(signatureImage);
                console.log(Signatureimage2);
                this.signatureImage = signatureImage;
                this.bookingQuote.signatureImage = Signatureimage2;

                this.showImage();
            }
        }
        else {
            let Signatureimage2: string = this.getSignaturePayload(signatureImage);
            console.log(Signatureimage2);
            this.signatureImage = signatureImage;
            this.bookingQuote.signatureImage = Signatureimage2;

            this.showImage();
        }



    }

    drawStart() {
        console.log('Start drawing');
    }

    clear() {
        this.signaturePad.clear();
    }

    private getSignaturePayload(signatureImage: string): string {
        return signatureImage.replace(/^data:image\/png;base64,/, '');
    }

    ngAfterContentInit() {

        this.bookingQuote.remarks = this.qouteRemarks ? this.qouteRemarks : '';
        this.bookingQuote.isAlert = this.isAlert;
        if (this.signature) {
            this.signatureImage = this.signature;
            this.isSign = true;
        }
        this.signatureRequired();


    }


    signatureRequired() {

        if (this.PendingSignatureRequiredStatus && this.isSign == false && this.signatureImage == undefined) {
            this.isSignatureRequired = true;
            this.sign();

        } else if (this.PendingSignatureRequiredStatus && this.isSign == true && this.signatureImage != undefined) {
            this.isSignatureRequired = false;

        } else if (this.PendingSignatureRequiredStatus && this.isSign == true && this.signatureImage == undefined) {
            this.isSignatureRequired = true;

        } else if (this.PendingSignatureRequiredStatus == false) {
            this.isSignatureRequired = false;

        }


    }


    sign() {
        this.isSign = true;
    }
    resign() {
        this.signatureImage = undefined;
        this.signatureRequired();

    }
    cancel() {
        this.cancelQuote.emit();
    }
    finishQuote() {

        console.log('PostBooking - Quote');
        this.bookingQuote.mode = "Quote";
        this.confirmQuote.emit(this.bookingQuote);
    }
    splitFinishQuote() {
        console.log('PostBooking - Quote');
        this.bookingQuote.mode = "Quote";
        this.confirmSplitQuote.emit(this.bookingQuote);
    }
    numbersOnly(evt: KeyboardEvent) {
        if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
            evt.preventDefault();
        }
    }
}